import * as React from "react";
import {useEffect, useState} from "react";
import {CubeViewProps, TreemapResult} from "../types";
import useModelsApi from "../../../api/useModelsApi";
import {STreeMap} from "../../../../@satsui/components/STreeMap/STreeMap";

export const TreemapTab = ({modelUuid, query}: CubeViewProps) => {
    const modelsApi = useModelsApi();

    const [result, setResult] = useState<TreemapResult>()

    useEffect(() => {
        modelsApi.cubeTreemap(modelUuid, "Component", query).then((response) => {
            setResult(response?.data);
        });
    }, [modelsApi, query]);

    return <div>
        <STreeMap data={result?.map}/>
    </div>
}